// https://github.com/tvkhoa/react-tippy

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Tooltip as ReactTooltip } from 'react-tippy';

import 'styles/base/components/tooltip/_tooltip.scss';

const triggers = ['mouseenter hover', 'mouseenter', 'hover', 'click', 'manual'];

export default class Tooltip extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
    titleHtml: PropTypes.node,
    arrow: PropTypes.bool,
    trigger: PropTypes.oneOf(triggers)
  };

  static defaultProps = {
    title: 'Default tip',
    titleHtml: null,
    arrow: true,
    trigger: triggers[0]
  };

  render() {
    const { children, titleHtml, ...restProps } = this.props;

    return (
      <ReactTooltip
        {...restProps}
        html={titleHtml}
        theme="light"
      >
        {children}
      </ReactTooltip>
    );
  }
}
